import {isLaptopExactByScreen} from 'core/helpers';
import {useResize} from 'core/hooks/useResize';
import {useCallback, useState} from 'react';

export const useIsLaptopExact = () => {
    const [isLaptop, setIsLaptop] = useState<boolean>(isLaptopExactByScreen());
    const handleWindowResize = useCallback(() => setIsLaptop(isLaptopExactByScreen()), []);

    useResize(handleWindowResize);

    return isLaptop;
};
